module.exports = __webpack_public_path__ + "static/media/categories.4391f69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/food/categories.png
// module id = 662
// module chunks = 0